export const clamp01 = (value) => Math.max(0, Math.min(1, value));
export const lerp = (a, b, t) => a + (b - a) * t;
export const easeOutCubic = (value) => 1 - (1 - clamp01(value)) ** 3;
export const easeInOutCubic = (value) => {
  const t = clamp01(value);
  return t < 0.5 ? 4 * t ** 3 : 1 - (-2 * t + 2) ** 3 / 2;
};
export function easeOutBack(value, strength = 1.25) {
  const t = clamp01(value) - 1;
  return 1 + (strength + 1) * t ** 3 + strength * t ** 2;
}

export function reactionEnvelope(elapsed, duration) {
  return (
    easeOutCubic(elapsed / 170) *
    (1 - easeInOutCubic((elapsed - duration + 350) / 350))
  );
}
